import {
  IP_CITY_FETCH_ROUTE,
  IP_CITY_KEY,
  MAPPED_CITY_KEY,
} from "@constants/leadCapture";

export interface IpCityResponse {
  ip_city: string | null;
  mapped_city: string | null;
}

/**
 * Get city information from IP address with caching
 */
export async function getCityFromIp() {
  const cachedCity = sessionStorage.getItem(IP_CITY_KEY);
  if (cachedCity) {
    return cachedCity;
  }

  let ip_city = null;
  try {
    const res = await fetch(IP_CITY_FETCH_ROUTE);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    ip_city = data.ip_city;

    if (ip_city) {
      sessionStorage.setItem(IP_CITY_KEY, ip_city);
    }
  } catch (error) {
    console.error(`[GET IP CITY API] [FAILURE] error: ${error}`);
  }

  return ip_city;
}

export async function getCityDetailsFromIp(): Promise<IpCityResponse> {
  const cachedIpCity = sessionStorage.getItem(IP_CITY_KEY);
  const cachedMappedCity = sessionStorage.getItem(MAPPED_CITY_KEY);

  if (cachedIpCity && cachedMappedCity) {
    return {
      ip_city: cachedIpCity,
      mapped_city: cachedMappedCity,
    };
  }

  let ip_city: string | null = cachedIpCity;
  let mapped_city: string | null = cachedMappedCity;

  try {
    const res = await fetch(IP_CITY_FETCH_ROUTE);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    ip_city = data.ip_city;
    mapped_city = data.mapped_city;

    if (ip_city) {
      sessionStorage.setItem(IP_CITY_KEY, ip_city);
    }
    if (mapped_city) {
      sessionStorage.setItem(MAPPED_CITY_KEY, mapped_city);
    }
  } catch (error) {
    console.error(`[GET IP CITY API] [FAILURE] error: ${error}`);
  }

  return { ip_city, mapped_city };
}